<template>
  <div>
    <v-dialog
      v-model="planDialog"
      width="410px">
      <div class="dialog-container">
        <div class="plan-header">
          <div class="info flex">
            <span>Set Manual Discount/Admin Charge</span>
            <i
              class="el-icon-close"
              @click="changeDialog"></i>
          </div>
        </div>
        <div class="dialog-body">
          <div class="flex-content">
            <div class="flex-box">
              <div
                v-for="(item, index) in sidebarPremium"
                :key="index"
                class="flex-info">
                <span>{{ item.item }}</span>
                <!--                <span>{{ item.premium | formatMoney(2, true) }}</span>-->
                <span>{{ item.premium | formatMoney(2, true) }}</span>
              </div>
              <!--              <div-->
              <!--                v-if="isFina"-->
              <!--                class="flex-info">-->
              <!--                <span>MGM Discount</span>-->
              <!--                &lt;!&ndash;                <el-form-item&ndash;&gt;-->
              <!--                &lt;!&ndash;                  ref="code_disc_prm"&ndash;&gt;-->
              <!--                &lt;!&ndash;                  prop="code_disc_prm">&ndash;&gt;-->
              <!--                <span>-->
              <!--                  <v-input-->
              <!--                    v-model.number="code_disc_prm"-->
              <!--                    prepend="-$"-->
              <!--                    :keyFloatNumber="true"-->
              <!--                    maxlength="8"-->
              <!--                    disabled-->
              <!--                    :min="0"-->
              <!--                    @blur="computedDiscount"></v-input>-->
              <!--                </span>-->
              <!--                &lt;!&ndash;                </el-form-item>&ndash;&gt;-->
              <!--              </div>-->
              <!--              <div-->
              <!--                v-if="!isFina&&code_disc_prm"-->
              <!--                class="flex-info">-->
              <!--                <span>MGM Discount</span>-->
              <!--                <span>-{{ code_disc_prm | formatMoney(2, true) }}</span>-->
              <!--              </div>-->
              <div
                v-if="isRenew"
                class="flex-info ">
                <span>Renew Discount {{is_renew_discount?`(${form.renew_disc_pct}%)`:''}}</span>
                <span>
                  <span
                    v-if="is_renew_discount"
                    class="mg-l-8">-{{form.renew_disc_prm | formatMoney(2, true)}}</span>
                  <span class="mg-l-8">{{is_renew_discount?'On':'Off'}}</span>
                  <el-switch
                    v-model="is_renew_discount"
                    :active-value="1"
                    :inactive-value="0"
                    :disabled="is_renew_disable "
                    :active-color="'#DDF4FF'"
                    :inactive-color="'#EAEEF2'"
                    @change="computedDiscount"
                  >
                  </el-switch>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Promo Discount</span>
                <span>
                  <v-input
                    v-model="promo_disc_prm"
                    :keyFloatNumber="true"
                    prepend="- $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Manual Discount</span>
                <span>
                  <v-input
                    v-model="spec_disc_prm"
                    :keyFloatNumber="true"
                    prepend="- $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Insurer Admin Charge</span>
                <span>
                  <v-input
                    v-model="insurer_handling_fee"
                    :keyFloatNumber="true"
                    prepend="+ $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Agency Admin Charge</span>
                <span>
                  <v-input
                    v-model="agency_handling_fee"
                    :keyFloatNumber="true"
                    prepend="+ $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info ">
                <span>Total Admin Charge</span>
                <span>
                  <v-input
                    v-model="handling_fee"
                    :keyFloatNumber="true"
                    prepend="+ $"
                    disabled
                    @blur="computedDiscount"></v-input>
                </span>
              </div>

              <div
                class="flex-info ">
                <span>IA Levy Discount</span>
                <span>
                  <v-input
                    v-model="ia_levy_disc_prm"
                    :keyFloatNumber="true"
                    prepend="- $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <template v-if="showDiscount||productId>=80">
                <div
                  class="flex-info ">
                  <span>EC Levy Discount</span>
                  <span>
                    <v-input
                      v-model="ec_levy_disc_prm"
                      :keyFloatNumber="true"
                      prepend="- $"
                      @blur="computedDiscount"></v-input>
                  </span>
                </div>
              </template>
              <div
                v-if="productId == 11"
                class="flex-info ">
                <span>MIB Discount</span>
                <span>
                  <v-input
                    v-model="mib_disc_prm"
                    :keyFloatNumber="true"
                    prepend="- $"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                v-if="referrer_is_special"
                class="flex-info">
                <span>Referrer Discount</span>
                <span>
                  <v-input
                    v-model.number="code_disc_prm"
                    prepend="-$"
                    :keyFloatNumber="true"
                    key-non-chinese
                    :max="max_code_disc_prm"
                    :min="0"
                    @blur="computedDiscount"></v-input>
                </span>
              </div>
              <div
                class="flex-info total-amount">
                <span>Total Payable</span>
                <span class="amount">{{ amount | formatMoney(2, true) }}</span>
              </div>
            </div>
          </div>
          <code-select
            v-if="isShowCode"
            ref="codeForm"
            :orderId="orderId"
            :notApply="true"
            :isQuote="false"
            :customerId="customer_id"
            :customer="customer"
            is-referral-option
            :is-fina="isFina"
            :isGuest="isGuest"
            :isRenew="is_renew_discount==1&&isRenew"
            :is-user="true"
            @check-code="applyCode"
          ></code-select>
          <!--          <div-->
          <!--            v-if="showReferralSelect&&!isFina"-->
          <!--            class="mg-t-20 flex">-->
          <!--            &lt;!&ndash;            <span class="fs-14 color-dark fw-600 title margin-left">Referrer Discount</span>&ndash;&gt;-->
          <!--            <v-select-->
          <!--              v-model="referral_id"-->
          <!--              :list="referral_option_list"-->
          <!--              @change="computedReferDiscount"></v-select>-->
          <!--            <v-button-->
          <!--              gray-->
          <!--              class="mg-l-10"-->
          <!--              @click="handleInitRefer">Default</v-button>-->
          <!--          </div>-->
        </div>
        <div class="flex footer-button">
          <v-button @click="changeDialog">Close</v-button>
          <v-button
            type="success"
            @click="ConfirmCoupon">Save</v-button>
        </div>
      </div>
      <!--      <coupon-dialog-->
      <!--        ref="coupon-dialog"-->
      <!--        :customerId="customer_id"-->
      <!--        :orderId="orderId"-->
      <!--        :isQuote="false"-->
      <!--        :classId="classId"-->
      <!--        :class="{'has-append-body':true}"-->
      <!--        :customer="customer"-->
      <!--        @coupon="computedCoupon">-->
      <!--      </coupon-dialog>-->
    </v-dialog>
    <div>
      <attach-customer
        ref="attachCustomer"
        @handlerSelectCustomer="handlerSelectCoupon"></attach-customer>

    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinReferralOption from '@/mixins/referral-option'
import {searchQuoteDiscount, setQuoteDiscount} from '@/api/order'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import CodeSelect from '@/views/components/code-select'

export default {
  name: 'setManualDialog',
  components: {
    // selectDiscountFuc,
    attachCustomer,
    CodeSelect
  },
  mixins: [MixinOptions, MixinFormat,MixinReferralOption],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId:{
      type:[String,Number],
      default:''
    },
    isAmount:{
      default:false,
      type:Boolean,
    },
    isFina:{
      default:false,
      type:Boolean,
    },
    isShowCode: {
      type: Boolean,
      default: true
    },
    isSme:{
      type:Boolean,
      default:false
    },
  },
  data() {
    return {
      planDialog: false,
      coupon:'',
      amount:'',
      spec_disc_prm:'',
      promo_disc_prm:'',
      handling_fee:'',
      insurer_handling_fee:'',
      agency_handling_fee:'',
      code_disc_prm:'',
      mib_disc_prm:'',
      ia_levy_disc_prm:'',
      ec_levy_disc_prm:'',
      formData:{},
      modal:false,
      is_renew_discount:0
    }
  },
  computed: {
    ...mapState('common', ['productId']),
    ...mapState('coupon', ['selectCode']),
    referrer_is_special(){
      let {referrer_is_special} = this.form||{}
      return referrer_is_special
    },
    max_code_disc_prm(){
      let {max_code_disc_prm} = this.form||{}
      return max_code_disc_prm
    },
    customer() {
      let {isrd_nm} = this.form || {}
      return {
        isrd_nm,
        appendToBody:true
      }
    },
    isNewSME(){
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
    customer_id(){
      let {customer_id} = this.form||{}
      return customer_id||''
    },
    classId() {
      return this.form.class_id || 14
    },
    showDiscount(){
      let arr =[21,26,24]
      return arr.includes(this.classId)
    },
    premium_info(){
      let {sidebar_info} = this.form||{}
      let {premium_info=[]} =sidebar_info||{}
      if(this.isNewSME){
        return  sidebar_info
      }
      return premium_info||[]
    },
    sidebarPremium() {
      let coverageList
      if(this.isSme){
        coverageList =this.premium_info
      }else {
        let {sidebar_premium} = this.form.quote_coverage_list||{}
        coverageList = sidebar_premium
      }
      if(!coverageList) {
        return []
      }
      let {spec_disc_prm,handling_fee,agency_handling_fee,insurer_handling_fee,sidebar_info={},code_disc_prm,promo_disc_prm} = this.form
      this.spec_disc_prm = spec_disc_prm
      this.handling_fee  =handling_fee
      this.agency_handling_fee  =agency_handling_fee
      this.insurer_handling_fee  =insurer_handling_fee
      this.code_disc_prm  =code_disc_prm
      this.promo_disc_prm  =promo_disc_prm
      // if(this.isSme){
      //   this.spec_disc_prm = sidebar_info.spec_disc_prm||0
      //   this.handling_fee  =sidebar_info.handling_fee||0
      // }
      console.log('handling_fee--',handling_fee)
      let premium = coverageList.filter(item => !['agency_handling_fee','insurer_handling_fee','paid','handling_fee','spec_disc_prm','promo_disc_prm'].includes(item.name))
      // let premium = coverageList.filter(item => item.name != 'paid'&&item.name!='handling_fee'&&item.name!='spec_disc_prm'&&item.name!='promo_disc_prm')
      if(this.referrer_is_special){
        premium = premium.filter(item => item.name != 'code_disc_prm')
      }
      return premium
    },
    maxPrice(){
      let {spec_disc_prm}= this.form
      let num = (spec_disc_prm+this.amount).toFixed(2)
      return Number(num)
    },
    discountPrice(){
      // let {quote_coverage_list} = this.form||{}
      // let {sidebar_premium={}} = quote_coverage_list
      // let premum = sidebar_premium.filter(item => item.name == 'code_disc_prm'||item.name=='coupon')
      let {coupon_vl=0,code_disc_prm=0,prom_disc_prm=0} = this.form||{}
      return Number(coupon_vl||0) + Number(code_disc_prm||0)+Number(this.promo_disc_prm||0)
    },
    // amountResult() {
    //   // if(this.isAmount)
    //   //   return  this.amount
    //   // else
    //   //   return Number(this.amount) - Number(this.spec_disc_prm) + Number(this.handling_fee) - this.discountPrice
    //
    // },
    isGuest(){
      return this.form.is_share_guest_order == 1
    },
    isRenew(){
      // return  false
      return this.form.type == 20
    },
    is_renew_disable(){
      // return  false
      let {is_renew_disable=0} = this.form
      return is_renew_disable==1
    },
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        // this.amount = val.amount
        const {referrer, referrer_user_id,ec_levy_disc_prm,ia_levy_disc_prm,mib_disc_prm} = val
        // this.amount = this.isSme?Number(val.amount):val.gross
        this.amount = Number(val.amount)
        let {code,coupon_code,sidebar_info={},renew_disc_pct=0,is_renew_discount,renew_disc_rate,campaign_code} = val||{}
        let useCode = this.isSme&&!this.isNewSME?sidebar_info.code:code
        let use_coupon_code = this.isSme&&!this.isNewSME?sidebar_info.coupon_code:coupon_code
        this.renew_disc_pct = renew_disc_pct
        this.is_renew_discount = is_renew_discount
        this.mib_disc_prm = mib_disc_prm
        this.ia_levy_disc_prm = ia_levy_disc_prm
        this.ec_levy_disc_prm = ec_levy_disc_prm
        let params = {}
        if(useCode||this.isFina&&referrer.code)
        {
          params.code = {
            code: this.isFina?referrer.code:useCode||'',
            referrer,
            referrer_user_id
          }
        }
        if(use_coupon_code)
          params.coupon = { title:use_coupon_code,coupon_code:use_coupon_code}
        if(campaign_code)
        {
          params.coupon= {coupon_code:campaign_code,title:campaign_code}
          params.is_campaign_code = 1
        }
        this.setSelectCode(params)
        // if(this.isRenew&&code&&!this.isFina){
        //   this.mixinNetwork().getOrderReferralList()
        // }
      }
    },

  },
  methods: {
    ...mapActions('coupon', ['setSelectCode', 'setCouponData']),
    handleInitRefer(){
      this.initReferrerId()
      this.computedReferDiscount()
    },
    // handlerCoupon() {
    //   if (!this.customer_id) {
    //     this.$refs.attachCustomer.showAttachCustomer()
    //   } else {
    //     this.$refs['coupon-dialog'].changeDialog()
    //   }
    // },
    handlerSelectCoupon() {
      this.$refs['coupon-dialog'].changeDialog()
    },
    changeDialog() {
      this.planDialog = !this.planDialog
    },
    ConfirmCoupon(){
      this.planDialog =false
      this.network().setQuoteDiscount({send:true})
    },
    applyCode(code) {
      this.network().searchQuoteDiscount()
    },
    computedDiscount() {
      this.network().searchQuoteDiscount()
    },
    computedReferDiscount(){
      this.network().setQuoteDiscount({},true)
    },
    network() {
      return {
        setQuoteDiscount: async (params,isRefer=false) => {
          params = {...params}
          let {coupon, code,is_campaign_code} = this.selectCode || {}
          let {coupon_code}  = coupon||{}
          params.coupon_code = coupon_code
          if(this.isRenew){
            params.is_renew_discount = this.is_renew_discount
          }
          // if(!this.isFina){
          params.code =code&&code.code
          params = {
            ...params,
            ...this.code_discount_info
          }
          if(is_campaign_code){
            params.campaign_code = coupon_code
            delete params.coupon_code
          }
          // }
          if(this.referrer_is_special){
            params.code_disc_prm = this.code_disc_prm
          }
          const {data} = await setQuoteDiscount({
            order_id: this.orderId,
            spec_disc_prm:this.spec_disc_prm,
            // handling_fee:this.handling_fee,
            insurer_handling_fee:this.insurer_handling_fee,
            agency_handling_fee:this.agency_handling_fee,
            promo_disc_prm:this.promo_disc_prm,
            mib_disc_prm:this.mib_disc_prm,
            ia_levy_disc_prm:this.ia_levy_disc_prm,
            ec_levy_disc_prm:this.ec_levy_disc_prm,
            ...params,
          })
          this.handling_fee = data.handling_fee
          // if(params.code){
          let {campaign_code} = params||{}
          this.mixinNetwork().getOrderReferralList({code:params&&params.code||campaign_code||''})
          // }
          this.$emit('saveManual',params.send)
        },
        searchQuoteDiscount: async (params,isRefer=false) => {
          params = {...params}
          let {coupon, code,is_campaign_code} = this.selectCode || {}
          let {coupon_code}  = coupon||{}
          params.coupon_code = coupon_code
          if(this.isRenew){
            params.is_renew_discount = this.is_renew_discount
          }
          params.code =code&&code.code||''
          params = {
            ...params,
            ...this.code_discount_info
          }
          if(is_campaign_code){
            params.campaign_code = coupon_code
            delete params.coupon_code
          }
          // }
          if(this.referrer_is_special){
            params.code_disc_prm = this.code_disc_prm
          }
          const {data} = await searchQuoteDiscount({
            order_id: this.orderId,
            spec_disc_prm:this.spec_disc_prm,
            // handling_fee:this.handling_fee,
            insurer_handling_fee:this.insurer_handling_fee,
            agency_handling_fee:this.agency_handling_fee,
            promo_disc_prm:this.promo_disc_prm,
            mib_disc_prm:this.mib_disc_prm,
            ia_levy_disc_prm:this.ia_levy_disc_prm,
            ec_levy_disc_prm:this.ec_levy_disc_prm,
            ...params,
          })
          let {amount,promo_disc_prm,code_disc_prm,handling_fee} = data||{}
          this.amount = amount
          this.promo_disc_prm = promo_disc_prm
          this.code_disc_prm = code_disc_prm
          this.handling_fee = handling_fee
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .dialog-body{
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;
  }
  .footer-button{
    padding: 15px;
    justify-content: space-between;
  }
  .flex-content {
    //width: 280px;
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      //width: 280px;
      margin: 16px 0;

      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 23px 15px;
        border-bottom: 1px solid #E1E4E8;
        .mg-l-8{
          margin-right: 8px;
          font-weight: 400!important;
          font-size: 12px!important;
          line-height: 18px;
          color: #24292E!important;
        }
        /deep/ .el-switch{
          .el-switch__core{
            border-radius: 6px;
            border: 1px solid #AFB8C1;
            &:after{
              top: 0;
              border-radius: 6px;
              background: #F6F8FA;
              border: 1px solid #AFB8C1;
            }
            &:before{
              content: 'O';
              position: absolute;
              right: 5px;
            }
          }
          &.is-checked{
            .el-switch__core{
              border: 1px solid #54AEF4;
              &:after{
                background: #0366D6;
              }
              &:before{
                content: 'I';
                left: 10px;
                position: absolute;
              }
            }
          }

        }
        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight: 500;
        }

        span:last-child {
          color: #24292E;
          font-size: 14px;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
    }
    .coupon-button{
      .el-button{
        width: 100%;
      }
      .margin-right{
        margin-right: 10px;
      }
    }
    .coupon-data{
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border: 1px solid #D1D5DA;
      border-radius: 5px;
      padding: 16px;
      .coupon-title{
        color: #24292E;
        font-size: 16px;
        font-weight: 600;
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .coupon-des{
        text-overflow: ellipsis;
        word-break: break-word;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        font-size: 12px;
        margin-top: 8px;
        -webkit-box-orient: vertical;
        color: #586069;
      }
    }
  }
}
</style>
